import validateConfig from "../validateConfig";
const getConfig = (config) => {
    validateConfig(config);
    return structuredClone(config);
};
export default getConfig;
